import { Close } from "@mui/icons-material";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import { useTranslation } from "react-i18next"
import { useState, useEffect } from 'react';

export const ModalNotes = ({ open, onClose, prodotto, note, onChange, readOnly = false }) => {
    const { t } = useTranslation();
    const [noteTemp, setNoteTemp] = useState(note || '');
    const [saving, setSaving] = useState(false);

    // sincronizza noteTemp quando cambia il prodotto o si riapre il modale
    useEffect(() => {
        setNoteTemp(note || '');
        setSaving(false);
    }, [note, open]);

    const handleSave = async () => {
        if (saving) return;
        setSaving(true);
        try {
            await onChange(prodotto.id, noteTemp);
            onClose();
        } catch {
            setSaving(false);
        }
    };

    return (
        <Dialog maxWidth='md' fullWidth open={open} onClose={onClose}>
            <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                <DialogTitle pb={1}>
                    {t('booking.notes')} - {prodotto?.name || prodotto?.product?.name || ''}
                </DialogTitle>
                <IconButton disabled={saving} onClick={onClose} sx={{ pr: "20px" }}>
                    <Close />
                </IconButton>
            </Box>
            <DialogContent>
                <TextField
                    fullWidth
                    multiline
                    rows={6}
                    value={noteTemp}
                    InputProps={{ readOnly: readOnly }}
                    onChange={(e) => setNoteTemp(e.target.value)}
                />
            </DialogContent>
            {!readOnly &&
                <DialogActions>
                    <Button disabled={saving} variant='outlined' onClick={() => {
                        setNoteTemp(note || ''); // ripristina il valore originale
                        onClose();
                    }}>
                        {t('cancel')}
                    </Button>
                    <Button disabled={saving} variant='contained' onClick={handleSave}>
                        {saving ? <CircularProgress size={18} color="inherit" /> : t('save')}
                    </Button>
                </DialogActions>
            }
        </Dialog>
    );
};
